import AuditsModal from "./AuditsModal";

export default AuditsModal;
